import React from 'react';
import { List, Typography } from 'antd';
import ReactEcharts from 'echarts-for-react'
import {thousands} from '../../utils'
const CreatePieChart = (option) => {
  return {
    title: {
        text: '地名遗产',
        subtext: '数据信息',
        left: 'center'
    },
    tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)'
    },
    legend: {
        type: 'scroll',
        orient: 'vertical',
        right: 10,
        top: 20,
        bottom: 20,
        data: option.data,
  
        // selected: data.selected
    },
    series: [
        {
            name: '姓名',
            type: 'pie',
            radius: '55%',
            center: ['40%', '50%'],
            data: option.data,
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }
    ]
  };
  
}
const ScenicList = (props) => {
  
  let {scenic} = props
  const tempArr = []
  for(let item of scenic ){
    tempArr.push({value:item.clickcount,name:item.title})
  }
  const option = CreatePieChart({data:tempArr})
    return (
        <div className="scenicList">
          <ReactEcharts option={option} className='echarts-for-echarts' style={{
            width:'400px',
            height: '400px'
          }}></ReactEcharts>
            {/* <List
        header={<div>地名文化</div>}
        bordered
        dataSource={scenic}
        renderItem={item => (
          <List.Item>
            {item.title}
          </List.Item>
        )}
      /> */}
        </div>
    );
};

export default ScenicList;